module.exports = __webpack_public_path__ + "static/media/ri_whatsapp-line.e7f31d14.svg";